<template>
  <div class="pa-3 grey lighten-4">
    <v-card fill-height>
      <v-card-title class="grey lighten-4 pa-2">
        <h3 class="secondary--text">{{ $t("company.details.title") }}</h3>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="$emit('onSave',film)" small>Save</v-btn>
      </v-card-title>

      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              v-model="film.title"
              :label="$t('screener.film.title')"
              color="primary"
              :rules="[
                rules.required,
                rules.min_length(3),
                rules.max_length(250),
              ]"
              counter="250"
            >
              <v-tooltip slot="append" color="white" top>
                <v-icon slot="activator">$vuetify.icons.rms_help_circle</v-icon>
                <span class="greyDarken3--text body-1">{{
                  $t("rms.help.text.film.input_field.title")
                }}</span>
              </v-tooltip>
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="film.subtitle"
              :label="$t('screener.film.subtitle')"
              color="primary"
              :rules="[rules.min_length(3), rules.max_length(250)]"
              counter="250"
            >
              <v-tooltip slot="append" color="white" top>
                <v-icon slot="activator">$vuetify.icons.rms_help_circle</v-icon>
                <span class="greyDarken3--text body-1">{{
                  $t("rms.help.text.film.input_field.original_title")
                }}</span>
              </v-tooltip>
            </v-text-field>
          </v-flex>
          <v-layout row wrap class="pt-2">
            <v-flex xs4 class="pl-1 pr-4">
              <v-text-field
                v-model="film.length"
                :label="$t('rms.field.length.label')"
                type="number"
              ></v-text-field>
            </v-flex>
            <v-flex xs4 class="pl-1 pr-4">
              <v-text-field
                v-model="film.director_name"
                :label="$t('screener.film.director.title')"
                type="text"
              ></v-text-field>
            </v-flex>
            <v-flex xs4 class="pl-4 pr-1">
              <v-text-field
                v-model="film.producer_name"
                :label="$t('screener.film.producer.title')"
                type="text"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-flex xs12 class="pt-2">
            <VimeoUploader
              @setUrl="setTrailer"
              v-model="film.trailer"
              label="Upload Trailer"
              :previewTitle="$t('screener.film.trailer_link.title')"
              refName="trailer"
            />
          </v-flex>
          <v-flex xs12>
            <!-- Description -->
            <TextEditor
              :title="$t('screener.film.description')"
              v-model="film.description"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-card fill-height class="mt-4">
      <v-card-title class="grey lighten-4 pa-2">
        <h4 class="secondary--text">
          {{ $t("screener.avails.additional_metadata.title") }}
        </h4>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="$emit('onSave',film)" small>Save</v-btn>
      </v-card-title>

      <v-card-text>
        <MediaMetadata 
        :film.sync="film"
        ref="mediaMetaData"
        ></MediaMetadata>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import rules from "@/validation";
import TextEditor from "@/components/TextEditor";
import MediaMetadata from "@/components/media/MetadataForm";
import VimeoUploader from "@/components/VimeoUploader";
export default {
  name: "FilmBasicDetails",
  props: {
    film: {
      type: Object,
      default: null,
    },
  },
  components: {
    TextEditor,
    MediaMetadata,
    VimeoUploader,
  },
  data() {
    return {
      rules,
    };
  },
  methods: {
    setTrailer(url) {
      this.film.trailer = url;
      this.$emit("onSave", this.film);
    },
  },
};
</script>
